module.exports = __webpack_public_path__ + "img/road-indicator.7774b9b5.png";